import colors, { getContrastSafeColor } from '../../../styles/colors';

// The sticker is printed matter: warm paper and near-black ink, whatever the coach's theme.
const PAPER = '#FBF6F1';
const INK = '#1F0A0C';

/**
 * The colors a story is drawn in: the coach's checkout theme for the page, the coach's color as the accent, and
 * paper and ink for the sticker. Any accent works, because text on it, or in it, falls back to a readable color.
 *
 * @param {import('./shareCard').ShareCard} card
 * @returns {{ background: string, accent: string, onAccent: string, paper: string, ink: string,
 *   accentOnPaper: string }}
 */
const getStoryPalette = ({ brandColor, isDarkTheme }) => ({
  // A light page is off-white rather than white, so the sticker's paper edge still shows.
  background: isDarkTheme ? colors.shades.dark1 : colors.shades.gamma4,
  accent: brandColor,
  onAccent: getContrastSafeColor(brandColor, INK, colors.base.alpha),
  paper: PAPER,
  ink: INK,
  accentOnPaper: getContrastSafeColor(PAPER, brandColor, INK),
});

export default getStoryPalette;
